// extracted by mini-css-extract-plugin
module.exports = {"fade":"Crawl_fade__16B6i","starWars":"Crawl_starWars__2lo8y","pre":"Crawl_pre__17cyi","crawl":"Crawl_crawl__3YH1B","stopCrawl":"Crawl_stopCrawl__2yUb8"};